export const TABLE_EDITOR_DEFAULT_COLUMN_WIDTH_CSS_PX = 120;
